import { buildLoginUrl } from '@pickleballinc/lib/session/login-url';

import { IS_LOCALHOST } from '@/components/constants/constants';
import { publicEnv } from '@/lib/env';

/** A "Log in" link or redirect: SSO's login, or the local `/login` on localhost. See `buildLoginUrl`. */
export const getLoginUrl = (continueTo?: string | URL) =>
	buildLoginUrl({ ssoUrl: publicEnv.NEXT_PUBLIC_SSO_URL, isLocalhost: IS_LOCALHOST, continueTo });
